'use client'
/* eslint-disable @typescript-eslint/naming-convention */
// Contexts
import React, { createContext, useContext } from 'react'
// Hooks
// Utils
import { getTexts, type ILanguage } from '@/lib/i18n'
import S from '@/settings'
type ILanguageContext = { lang: ILanguage; texts: ReturnType<typeof getTexts> }
const LanguageContext = createContext<ILanguageContext>({
  lang: S.DEFAULT_LANGUAGE,
  texts: getTexts(S.DEFAULT_LANGUAGE),
})

export const useTexts = () => useContext(LanguageContext).texts
export const useLanguage = () => useContext(LanguageContext).lang

export const LanguageProvider = ({ lang, children }: { lang: ILanguage; children: React.ReactNode }) => (
  <LanguageContext.Provider value={{ lang, texts: getTexts(lang) }}>{children}</LanguageContext.Provider>
)
